<template>
  <transition name="fade" mode="out-in" @before-enter="beforeEnter">
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  methods: {
    beforeEnter() {
      this.$root.$emit('scrollBeforeEnter');
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
